/**
 * Error Codes
 *
 * Standardized error codes shared between frontend and backend.
 * These provide machine-readable error identification for API responses.
 *
 * Usage:
 * - Backend: Use with AppError classes in lib/errors.ts
 * - Frontend: Use with ApiError class in lib/apiErrors.ts
 */

/**
 * Standard API error codes
 *
 * Each code maps to a specific HTTP status and error category.
 */
export const ERROR_CODES = {
  // Client errors (4xx)
  /** 400 - General bad request */
  BAD_REQUEST: 'BAD_REQUEST',
  /** 400 - Input validation failed */
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  /** 401 - Authentication required */
  UNAUTHORIZED: 'UNAUTHORIZED',
  /** 403 - Permission denied */
  FORBIDDEN: 'FORBIDDEN',
  /** 403 - User lost access to selected workspace (removed from membership) */
  WORKSPACE_ACCESS_LOST: 'WORKSPACE_ACCESS_LOST',
  /** 403 - User has no workspace memberships */
  NO_WORKSPACE: 'NO_WORKSPACE',
  /** 404 - Resource not found */
  NOT_FOUND: 'NOT_FOUND',
  /** 409 - Resource conflict (e.g., duplicate, dependency) */
  CONFLICT: 'CONFLICT',
  /** 429 - Too many requests */
  RATE_LIMITED: 'RATE_LIMITED',

  // Server errors (5xx)
  /** 500 - Internal server error */
  INTERNAL_ERROR: 'INTERNAL_ERROR',
  /** 502 - Bad gateway */
  BAD_GATEWAY: 'BAD_GATEWAY',
  /** 503 - Service unavailable */
  SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
  /** 504 - Gateway timeout */
  TIMEOUT: 'TIMEOUT',
} as const;

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];
